import type { QueryClient, QueryKey } from "@tanstack/react-query";

/** The element holding a pre-rendered page's catalog data, so the browser's first render matches its HTML. */
export const PRERENDER_DATA_ID = "prerender-data";

export interface PrerenderedQuery {
  queryKey: QueryKey;
  data: unknown;
}

/** A product list from the build: no prices or stock, which are only ever shown live. */
export const isSnapshot = (data: object) => "snapshot" in data;

/** Puts the page's data in the cache, as already out of date, so the live data replaces it straight away. */
export function seedPrerenderedQueries(client: QueryClient) {
  const block = document.getElementById(PRERENDER_DATA_ID);
  if (!block?.textContent) return;
  const queries = JSON.parse(block.textContent) as PrerenderedQuery[];
  for (const { queryKey, data } of queries) client.setQueryData(queryKey, data, { updatedAt: 1 });
}
